module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av322-f6b3ef743847d45f517c1435f78c4d93.jpg";